module.exports = __webpack_public_path__ + "static/dialog-49aed4a6b0302519bad51306648c7a2e.png";